<style lang="less">
.message-login-title {
  color: #e6a23c;
  font-size: 16px;
}
.message-login-txt {
  font-size: 16px;
}
.message-login-content {
  padding: 10px;
}
</style>
<template>
  <el-container class="layout">
    <el-header>
      <a href="javascript:;"
         @click="handleBackHome">
        <img :src="logoheader" />
        <template v-if="this.$route.name!='main'">
          <img :src="backhome" />
          <div>首页</div>
        </template>
      </a>
      <div class="header-title">
        <template v-if="this.$route.name!='main'">{{tenantName}} •</template>
        {{this.$route.meta.title}}
      </div>
      <div class="sign-out">
        <a class="wea"
           href="javascript:;"
           @click="showCalendar(0)">{{newDate}}{{JQ}}</a>
        <div class="wea city">
          <img src="../image/personLocation.png" />
          <span>{{city}}</span>
        </div>
        <a class="wea city-info"
           href="javascript:;"
           @click="showCalendar(1)">
          <img :src="wea_img" />
          <span>{{tem}}</span>℃
        </a>
        <!-- <div class="wea city-temp">
          <span>{{wea}}</span>
        </div>-->
        <a class="wea temp-detail"
           href="javascript:;"
           @click="showCalendar(1)">{{tem2}}~{{tem1}}℃</a>
        <span class="user">{{userName}}</span>
        <a href="javascript:;"
           @click="stop">
          <img src="../image/tuichu.png" />
          <span>退出</span>
        </a>
      </div>
    </el-header>
    <!--  -->
    <el-dialog class="calendardialog"
               :visible.sync="centerDialogVisible"
               :modal-append-to-body="false">
      <span class="el-icon-circle-close"
            @click="closeDialog(0)"></span>
      <iframe src="../../static/demo.html"
              width="598"
              height="430"
              frameborder="0"
              scrolling="auto"
              style="border-radius: 8px;"></iframe>
    </el-dialog>
    <el-dialog class="weadialog"
               :visible.sync="centerWeaDialogVisible"
               :modal-append-to-body="false">
      <span class="el-icon-circle-close"
            @click="closeDialog(1)"></span>
      <a class="more"
         href="http://www.weather.com.cn/weather40d/101190201.shtml"
         target="_blank">
        查看更多
        <span class="el-icon-d-arrow-right"></span>
      </a>
      <iframe scrolling="no"
              src="https://tianqiapi.com/api.php?style=tw&skin=pitaya"
              frameborder="0"
              width="300"
              height="500"
              allowtransparency="true"></iframe>
    </el-dialog>
    <el-main>
      <router-view />
    </el-main>
  </el-container>
</template>
<script>
import { localToken } from "@/libs/util";
import { MessageBox } from "element-ui";
import axios from 'axios'
axios.defaults.withCredentials = false;//让ajax携带cookie

import bingbao from "@/assets/weather/bingbao.png";
import lei from "@/assets/weather/lei.png";
import qing from "@/assets/weather/qing.png";
import shachen from "@/assets/weather/shachen.png";
import wu from "@/assets/weather/wu.png";
import xue from "@/assets/weather/xue.png";
import yin from "@/assets/weather/yin.png";
import yu from "@/assets/weather/yu.png";
import yun from "@/assets/weather/yun.png";
import common from "@/libs/common";
import globConfig from "@/config/config";

import logoheader from "@/assets/logoheader.png";
import backhome from "@/assets/backhome.png";

// import calendar from "./main/calendar.vue";
import $ from "jquery";
export default {
  name: "layout",
  // components: {
  //   calendar
  // },
  data () {
    return {
      // 天气接口信息
      city: "",
      wea_img: qing,
      wea: "",
      tem: "",
      tem2: "",
      tem1: "",
      pic: {
        bingbao: bingbao,
        lei: lei,
        qing: qing,
        shachen: shachen,
        wu: wu,
        xue: xue,
        yin: yin,
        yu: yu,
        yun: yun
      },
      userName: "",
      tenantName: "",
      timer: null,
      logoheader: logoheader,
      backhome: backhome,
      JQ: "",
      newDate: "",
      centerDialogVisible: false,
      centerWeaDialogVisible: false
    };
  },
  methods: {
    handleBackHome () {
      this.$router.replace({ path: "/main" });
    },
    stop () {
      let that = this;
      const h = that.$createElement;
      MessageBox({
        message: h("div", null, [
          h("i", {
            class: "el-icon-warning message-login-title"
          }),
          h("span", { class: "message-login-txt" }, " 提示"),
          h("p", { class: "message-login-content" }, "您确认退出该系统？ ")
        ]),
        showCancelButton: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            localToken.clearLocal();
            that.$router.push({
              path: "/login"
            });
            // let tenant_id = localToken.getTenant();
            // if (tenant_id && tenant_id != "undefined") {
            //   that.$router.push({
            //     path: "/" + tenant_id + "/login"
            //   });
            // } else {
            //   that.$router.push({
            //     path: "/login"
            //   });
            // }
            clearInterval(that.timer);
            that.timer = null;
            done();
          } else {
            done();
          }
        }
      });
    },
    getWeather () {
      let that = this;
      common.getWeather().then(
        res => {
          that.city = res.city;
          that.wea_img = that.pic[res.wea_img];
          that.tem = res.tem;
          that.wea = res.wea;
          that.tem2 = res.tem2;
          that.tem1 = res.tem1;
          console.log(res);
        },
        err => { }
      )
    },
    showCalendar (val) {
      if (val) {
        this.centerWeaDialogVisible = true;
      } else {
        this.centerDialogVisible = true;
      }
    },
    closeDialog (val) {
      if (val) {
        this.centerWeaDialogVisible = false;
      } else {
        this.centerDialogVisible = false;
      }
    }
  },
  mounted () {
    let that = this;
    that.userName = localToken.getUser();
    that.tenantName = localToken.getTenantname();
    that.getWeather();
    setTimeout(that.getWeather(), 1000);
    that.timer = window.setInterval(() => {
      setTimeout(that.getWeather(), 0);
    }, 3600000);

    var sWeek = new Array("星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六");
    var dNow = new Date();
    var CalendarData = new Array(100);
    var madd = new Array(12);
    var tgString = "甲乙丙丁戊己庚辛壬癸";
    var dzString = "子丑寅卯辰巳午未申酉戌亥";
    var numString = "一二三四五六七八九十";
    var monString = "正二三四五六七八九十冬腊";
    var sx = "鼠牛虎兔龙蛇马羊猴鸡狗猪";
    var cYear, cMonth, cDay, TheDate;
    CalendarData = new Array(0xA4B, 0x5164B, 0x6A5, 0x6D4, 0x415B5, 0x2B6, 0x957, 0x2092F, 0x497, 0x60C96, 0xD4A, 0xEA5, 0x50DA9, 0x5AD, 0x2B6, 0x3126E, 0x92E, 0x7192D, 0xC95, 0xD4A, 0x61B4A, 0xB55, 0x56A, 0x4155B, 0x25D, 0x92D, 0x2192B, 0xA95, 0x71695, 0x6CA, 0xB55, 0x50AB5, 0x4DA, 0xA5B, 0x30A57, 0x52B, 0x8152A, 0xE95, 0x6AA, 0x615AA, 0xAB5, 0x4B6, 0x414AE, 0xA57, 0x526, 0x31D26, 0xD95, 0x70B55, 0x56A, 0x96D, 0x5095D, 0x4AD, 0xA4D, 0x41A4D, 0xD25, 0x81AA5, 0xB54, 0xB6A, 0x612DA, 0x95B, 0x49B, 0x41497, 0xA4B, 0xA164B, 0x6A5, 0x6D4, 0x615B4, 0xAB6, 0x957, 0x5092F, 0x497, 0x64B, 0x30D4A, 0xEA5, 0x80D65, 0x5AC, 0xAB6, 0x5126D, 0x92E, 0xC96, 0x41A95, 0xD4A, 0xDA5, 0x20B55, 0x56A, 0x7155B, 0x25D, 0x92D, 0x5192B, 0xA95, 0xB4A, 0x416AA, 0xAD5, 0x90AB5, 0x4BA, 0xA5B, 0x60A57, 0x52B, 0xA93, 0x40E95);
    madd[0] = 0;
    madd[1] = 31;
    madd[2] = 59;
    madd[3] = 90;
    madd[4] = 120;
    madd[5] = 151;
    madd[6] = 181;
    madd[7] = 212;
    madd[8] = 243;
    madd[9] = 273;
    madd[10] = 304;
    madd[11] = 334;

    function GetBit (m, n) {
      return (m >> n) & 1;
    }

    function e2c () {
      TheDate = (arguments.length != 3) ? new Date() : new Date(arguments[0], arguments[1], arguments[2]);
      var total, m, n, k;
      var isEnd = false;
      var tmp = TheDate.getFullYear();
      total = (tmp - 1921) * 365 + Math.floor((tmp - 1921) / 4) + madd[TheDate.getMonth()] + TheDate.getDate() - 38;
      if (TheDate.getYear() % 4 == 0 && TheDate.getMonth() > 1) {
        total++;
      }
      for (m = 0; ; m++) {
        k = (CalendarData[m] < 0xfff) ? 11 : 12;
        for (n = k; n >= 0; n--) {
          if (total <= 29 + GetBit(CalendarData[m], n)) {
            isEnd = true;
            break;
          }
          total = total - 29 - GetBit(CalendarData[m], n);
        }
        if (isEnd) break;
      }
      cYear = 1921 + m;
      cMonth = k - n + 1;
      cDay = total;
      if (k == 12) {
        if (cMonth == Math.floor(CalendarData[m] / 0x10000) + 1) {
          cMonth = 1 - cMonth;
        }
        if (cMonth > Math.floor(CalendarData[m] / 0x10000) + 1) {
          cMonth--;
        }
      }
    }

    /*戊戌狗年 腊月廿*/
    function GetcDateString () {
      var tmp = "";
      tmp += tgString.charAt((cYear - 4) % 10);
      tmp += dzString.charAt((cYear - 4) % 12);
      tmp += sx.charAt((cYear - 4) % 12);
      tmp += "年 ";
      if (cMonth < 1) {
        tmp += "(闰)";
        tmp += monString.charAt(-cMonth - 1);
      } else {
        tmp += monString.charAt(cMonth - 1);
      }
      tmp += "月";
      tmp += (cDay < 11) ? "初" : ((cDay < 20) ? "十" : ((cDay < 30) ? "廿" : "三十"));
      if (cDay % 10 != 0 || cDay == 10) {
        tmp += numString.charAt((cDay - 1) % 10);
      }
      return tmp;
    }

    function GetLunarDay (solarYear, solarMonth, solarDay) {
      if (solarYear < 1921 || solarYear > 2030) {
        return "";
      } else {
        solarMonth = (parseInt(solarMonth) > 0) ? (solarMonth - 1) : 11;
        e2c(solarYear, solarMonth, solarDay);
        return GetcDateString();
      }
    }


    function getFullYear (d) { // 修正firefox下year错误
      let yr = d.getYear();
      if (yr < 1000) yr += 1900;
      return yr;
    }

    /*写入页面*/
    function showDate () {

      var D = new Date();
      var yy = D.getFullYear();
      var mm = D.getMonth() + 1;
      var dd = D.getDate();
      var ww = D.getDay();
      var ss = parseInt(D.getTime() / 1000);
      var h = D.getHours();
      var m = D.getMinutes();
      var s = D.getSeconds();

      var sValue = "";// getFullYear(dNow) + "年" + (dNow.getMonth() + 1) + "月" + dNow.getDate() + "日" + " " + sWeek[dNow.getDay()] + " ";
      sValue += GetLunarDay(yy, mm, dd);
      // sValue += shapetime(h, m, s);
      // document.getElementById("pDate").innerHTML = sValue;
      that.newDate = sValue;
      // setTimeout("showDate()", 500);
    };

    /*格式化时间*/
    function shapetime (h, m, s) {
      if (s <= 9) s = "0" + s;
      if (m <= 9) m = "0" + m;
      if (h <= 9) h = "0" + h;
      return h + ":" + m + ":" + s
    }

    showDate()
    // that.newDate = GetLunarDay(yy, mm, dd);
    // var DateGL = new Date();
    // that.JQ = SolarTerm(DateGL);
    // that.newDate = CnDateofDateStr(DateGL);
  }
};
</script>
<style lang="less">
.el-container.is-vertical.layout {
  height: 100%;
  > .el-header {
    height: 7% !important;
    min-height: 43px;
    max-height: 60px;
    display: flex;
    align-items: center;
    background-color: #3f78e3;
    color: #fff;
    > a {
      z-index: 2;
      height: 75%;
      display: flex;
      align-items: center;
      color: #fff;
      img {
        height: 100%;
        max-height: 34px;
      }
      img:nth-child(2) {
        max-height: 32px;
        margin-left: 30px;
      }
    }
    a,
    a:focus,
    a:active,
    div {
      outline: none;
      color: #fff;
      text-decoration: none//underline;
    }
    .header-title {
      font-size: 18px;
      font-weight: 500;
      position: absolute;
      width: 100%;
      z-index: 1;
    }
    .sign-out {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      .user {
        margin-right: 20px;
      }
      a {
        z-index: 2;
        display: flex;
        align-items: center;
      }
      a:focus,
      a:active,
      span {
        outline: none;
        color: #fff;
        text-decoration: none//underline;
      }
      .wea {
        display: flex;
        height: 40px;
        align-items: center;
        margin-right: 16px;
        letter-spacing: 1px;
      }
      .city {
        height: auto;
        padding: 4px 10px 4px 8px;
        background-color: #ffffff1f;
        border-radius: 16px;
        font-size: 16px;
        margin-right: 10px;
      }
      .city-info {
        img {
          height: 32px;
        }
        span {
          font-size: 18px;
        }
      }
      .temp-detail {
        margin-right: 40px;
      }
    }
  }
  > .el-main {
    padding: 0px;
    background-color: #f7f7f7;
  }

  //日期弹出框
  .calendardialog .el-dialog {
    width: 598px !important;
    border-radius: 8px;
    .el-dialog__header {
      display: none !important;
    }
    .el-dialog__body {
      width: 598px !important;
      height: 430px !important;
      padding: 0px !important;
      border-radius: 8px;
      .el-icon-circle-close {
        position: absolute;
        top: -26px;
        right: -60px;
        color: #fff;
        font-size: 28px;
        font-weight: 500;
        cursor: pointer;
      }
    }
  }
  .weadialog .el-dialog {
    width: 498px !important;
    border-radius: 8px;
    .el-dialog__header {
      display: none !important;
    }
    .el-dialog__body {
      width: 498px !important;
      height: 500px !important;
      padding: 0px !important;
      border-radius: 8px;
      .el-icon-circle-close {
        position: absolute;
        top: -26px;
        right: -60px;
        color: #fff;
        font-size: 28px;
        font-weight: 500;
        cursor: pointer;
      }
      .more {
        color: #606266;
        position: absolute;
        right: 0px;
        padding: 15px;
        outline: none;
        text-decoration: none;
      }
    }
    iframe {
      width: 90%;
      margin: 0 5%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/layout/layout.vue